<template>
    <div class="licitacao-esclarecimento-impugnacao">
        <credenciamento-esclarecimento-impugnacao-vazio v-if="naoPossuiEsclarecimentoImpugnacao"/>
        <div v-else>
            <credenciamento-esclarecimento-tabela :esclarecimentos="esclarecimentosDados" @buscarEsclarecimentos="buscarEsclarecimentosLicitacao"/>
            <credenciamento-impugnacao-tabela :impugnacoes="impugnacaoDados" @buscarImpugnacoes="buscarImpugnacaoLicitacao"/>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import CredenciamentoEsclarecimentoImpugnacaoVazio from './CredenciamentoEsclarecimentoImpugnacaoVazio.vue'
    import CredenciamentoEsclarecimentoTabela from './CredenciamentoEsclarecimentoTabela.vue'
    import CredenciamentoImpugnacaoTabela from './CredenciamentoImpugnacaoTabela.vue'

    export default {
      name: 'CredenciamentoEsclarecimentoImpugnacao',
      components: {
        CredenciamentoImpugnacaoTabela,
        CredenciamentoEsclarecimentoTabela,
        CredenciamentoEsclarecimentoImpugnacaoVazio
      },
      props: {
        esclarecimentos: {
          type: Array,
          default: () => []
        },
        impugnacoes: {
          type: Array,
          default: () => []
        }
      },
      data() {
        return {
          esclarecimentosDados: [],
          impugnacaoDados: [],
          licitacaoId: null
        }
      },
      watch: {
        esclarecimentos: {
          immediate: true,
          handler(novos) {
            this.esclarecimentosDados = [...novos]
          }
        },
        impugnacoes: {
          immediate: true,
          handler(novos) {
            this.impugnacaoDados = [...novos]
          }
        }
      },
      computed: {
        naoPossuiEsclarecimentoImpugnacao() {
          return (!this.esclarecimentosDados.length && !this.impugnacaoDados.length)
        }
      },
      async mounted() {
        this.setLicitacaoId()
        await this.buscarImpugnacaoLicitacao()
        await this.buscarEsclarecimentosLicitacao()
      },
      methods: {
        ...mapActions([
          actionTypes.BUSCAR_ESCLARECIMENTOS,
          actionTypes.BUSCAR_IMPUGNACOES
        ]),
        async buscarEsclarecimentosLicitacao() {
          this.setMensagemLoading('Atualizando a listagem de esclarecimentos...')
          const resposta = await this.buscarEsclarecimentos(this.licitacaoId)
          if (resposta) {
            this.esclarecimentosDados = resposta.esclarecimentos
          }
        },
        async buscarImpugnacaoLicitacao() {
          this.setMensagemLoading('Atualizando a listagem de impugnações...')
          const resposta = await this.buscarImpugnacoes(this.licitacaoId)
          if (resposta) {
            this.impugnacaoDados = resposta.impugnacoes
          }
        },
        setLicitacaoId() {
          this.licitacaoId = this.$route.params.id
        }
      }
    }
</script>

<style scoped lang="stylus">
    .licitacao-esclarecimento-impugnacao
        min-height 59vh

</style>
